<template>
  <div class="blog">
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <!-- banner -->
    <div class="banner">
      <img v-if="!this.mobile" src="../../assets/img/blog_banner.png" alt="cart">
      <img v-if="this.mobile" src="../../assets/img/blog_banner_mobile.png" alt="cart">
      <div class="centered">
        <p>ASIAN FOOD GROCER</p>
        <p>BLOG</p>
      </div>
    </div>
    <!-- end banner -->
    <div class="blog-list-container">
      <ul>
        <li v-for="(item,index) in this.$store.state.blog.blogs" :key='index' @click="goToBlogDetail(item.blog_id)">
          <div class="blog-image">
            <img v-if="item.image_file" :src="item.image_file" alt="">
            <img v-else src="../../assets/img/coming.png" alt="">
          </div>
          <div class="blog-title">
           <p>{{item.title}}</p>
          </div>
        </li>
      </ul>
      <pagination
        :totalPages="pages"
        :total="count"
        :currentPage="currentPage"
        @pagechanged="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from '../../components/breadcrumb';
import pagination from '../../components/pagination';

export default {
  name: "blog",
  components: {
    breadcrumb,
    pagination,
  },
  data() {
    return {
      currentPage: 1,
      path2: this.$t('blog'),
    }
  },
  methods: {
    ...mapActions('blog', ['fetchBlogs, fetchBlogDetail']),
    ...mapMutations('blog', ['updategBlogId']),
    ...mapMutations('navbar', ['mobileDevice']),
    goToBlogDetail(id) {
      this.updategBlogId(id);
      this.$router.push(`/blog/${id}`);
    },
    onPageChange(page) {
      this.currentPage = page || 1;
      this.$store.dispatch('blog/fetchBlogs', page);
      window.scrollTo(0, 0);
    }
  },
  computed: mapState({
    mobile: state => state.navbar.mobile,
    pages: state => state.blog.blogsPaginate,
    count: state => state.blog.blogsCount,
  }),
  beforeMount() {
    if (window.screen.width <= 500) {
      this.mobileDevice(true);
    } else {
      this.mobileDevice(false);
    }
  },
  mounted() {
    this.$store.dispatch('blog/fetchBlogs', 1);
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/blog.less";
</style>



// WEBPACK FOOTER //
// src/view/blog/blog.vue